import React, { useCallback, useMemo } from 'react';

import cx from 'classnames';

import { useEscAction } from 'hooks/useEscAction';

import BluePlusButton from '../../../shared/BluePlusButton';
import { IContentBlock } from '../../../types';
import { getMenuItems } from '../../config';
import sceneClassNames from '../index.module.css';
import { useRevertMenu } from './functions';
import s from './index.module.css';
import { IBlocksMenuProps } from './types';

function BlocksMenu({ anchorRef, onAdd, onClose, handleChangeScene, isInsideAccordion }: IBlocksMenuProps) {
  useEscAction(onClose);
  const { menuRef, menuStyles, isReverted } = useRevertMenu(anchorRef || { current: null });
  const handleClick = useCallback(
    (block: IContentBlock) => {
      if (onAdd) {
        onAdd(block);
      }
      onClose();
    },
    [onAdd, onClose],
  );
  const menuItems = useMemo(
    () => getMenuItems({ handleClick, handleChangeScene, accordionDisabled: isInsideAccordion }),
    [handleClick, handleChangeScene],
  );

  return (
    <div className={sceneClassNames.sceneWrapper} style={menuStyles}>
      <div style={{ position: 'relative' }}>
        <div className={s.menuInner} ref={menuRef}>
          <div className={s.header}>Element Library</div>
          <div className={s.body}>
            <>
              {menuItems.map((row, i) => {
                return (
                  <div key={i} className={s.row}>
                    {row.map((item) => (
                      <div key={item.type} className={cx(s.item, item.disabled && s.disabled)} onClick={item.onClick}>
                        {item.iconComponent}
                        <div className={s.label}>{item.name}</div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </>
          </div>

          <div className={s.footer}>
            <strong>esc</strong> to dismiss
          </div>
        </div>
        <div className={cx(s.plusIconWrapper, isReverted && s.reverted)}>
          <BluePlusButton />
        </div>
      </div>
    </div>
  );
}

export default BlocksMenu;
